import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GetSuppliersQueryResponse, GetSupplierQueryResponse, CreateSupplierCommand } from '../../interfaces/interfaces';
import { SuppliersService } from '../suppliers.service';
import { MaintainSupplierComponent } from '../maintain-supplier/maintain-supplier.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";

@Component({
  selector: 'sdc-list-supplier',
  templateUrl: './list-supplier.component.html',
  styleUrls: ['./list-supplier.component.scss']
})
export class ListSupplierComponent implements OnInit {

  repairForm: UntypedFormGroup;
  isLoading = false;
  canEdit = false;
  chosenRepair: GetSuppliersQueryResponse;
  repairs = [];
  userName: string;
  role: string;

  public gridData: Observable<any>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 5,
  };
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public newDataItem: CreateSupplierCommand;
  public editDataItem: GetSupplierQueryResponse;
  public isNew: boolean;
  public repair: GetSupplierQueryResponse;

  constructor(
    private dialog: MatDialog,
    private repairService: SuppliersService,
  ) { }

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = localStorage.getItem('currentUserName');
    //this.role = localStorage.getitem('currentRole');
    this.intialiseData();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.gridData = this.repairService.getAllSuppliers().pipe(
      map((data) => process(data.suppliers, this.gridState))
    );
  }

  public addHandler(): void {
    this.editDataItem.id = 0; //new this.editDataItem();
    this.isNew = true;
  }

  public editHandler(args: AddEvent): void {
    this.editDataItem = args.dataItem;
    this.isNew = false;
  }

  public cancelHandler(): void {
    this.editDataItem = undefined;
  }

  public saveHandler(product: GetSupplierQueryResponse): void {
    this.editDataItem = undefined;
  }

  intialiseData(): void {

    this.gridData = this.repairService.getAllSuppliers().pipe(
      map((data) => process(data.suppliers, this.gridState))
    );
    
    this.repairService.getAllSuppliers().pipe(take(1)).subscribe({
      next: (response) => {
        this.chosenRepair = response;
        this.repairs = response.suppliers.map((data) => ({
          id: data.id,
          title: data.title,
        }));
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });
  }

  createRepair(): void {

    const dialogRef = this.dialog.open(MaintainSupplierComponent, {
      width: '30%',
      data: {
        id: 0,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
  }

  updateRepair(args: AddEvent): void {
    var sid = args.dataItem.id;
    this.repair = this.chosenRepair.suppliers.find(x => x.id === sid);
    const dialogRef = this.dialog.open(MaintainSupplierComponent, {
      width: '60%',
      data: this.repair,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
  }

}

